
























import {
    Banner,
    BannerDirectus,
} from '@src/federations/shared/cms/types/Banner';
import {
    SdsBannerPromo,
    SdsCarousel,
} from '@superbet-group/web.lib.ui-components';
import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { getRoutePathFromLink } from '@superbet-group/web.lib.utilities';
import {
    isInAppLink,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    ClickName,
    ProductType,
} from '@superbet-group/product.analytics';

export default defineComponent({
    props: {
        banners: {
            type: Array as PropType<Banner[]>,
            required: true,
        },
    },
    setup(props) {
        const { router } = useVueRouter();
        function openLink(banner: BannerDirectus, index: number) {
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.HOME_BANNER_CLICK,
                click: {
                    product_type: ProductType.SPORTS,
                    deep_link: banner.link,
                    deep_link_title: banner.title,
                    content_id: banner.id,
                    position: index,
                    start_time: banner.startDate.getTime(),
                    end_time: banner.endDate.getTime(),
                    type: 'deep_link_click',
                },
            });
            const link = banner.link;
            const actionType = banner.actionType;

            if (actionType === 'openInAppLink') {
                isInAppLink(link)
                    ? router.value.push(getRoutePathFromLink(link))
                    : window.open(link, '_self');
            } else {
                window.open(link);
            }
        }

        function resolveHrefForSeo(banner: BannerDirectus) {
            if (banner.actionType === 'openInAppLink' && isInAppLink(banner.link)) {
                return getRoutePathFromLink(banner.link);
            } else {
                return banner.link;
            }
        }

        const bannerSlides = computed(() => {
            return props.banners.map((banner, index) => ({ ...banner, id: index }));
        });

        return {
            bannerSlides,
            openLink,
            resolveHrefForSeo,
        };
    },
    components: {
        SdsCarousel,
        SdsBannerPromo,
    },
});
